import { createClient } from "tinacms/dist/client";
import { queries } from "./types";
export const client = createClient({ url: 'https://content.tinajs.io/1.4/content/50f40e89-6eb0-4f8a-91b3-2de8301293f3/github/main', token: 'bdb465f91a54dd2c47a26bb4ec5ddbc7311aa51b', queries,  });
export default client;
  